module.exports = __webpack_public_path__ + "static/media/boat.eb31acbe.svg";